import { render, staticRenderFns } from "./shipment-map.vue?vue&type=template&id=16c7af58&scoped=true&"
import script from "./shipment-map.vue?vue&type=script&lang=js&"
export * from "./shipment-map.vue?vue&type=script&lang=js&"
import style0 from "./shipment-map.vue?vue&type=style&index=0&id=16c7af58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c7af58",
  null
  
)

export default component.exports